import { render, staticRenderFns } from "./subEntity.vue?vue&type=template&id=16b4d51e&"
import script from "./subEntity.vue?vue&type=script&lang=js&"
export * from "./subEntity.vue?vue&type=script&lang=js&"
import style0 from "./subEntity.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports